// extracted by mini-css-extract-plugin
export default {"blue":"#00a9e0","blueDark":"#0098d8","custom":"Custom_custom__6lHP5"};